/**
 * 告警邮箱模块 Vuex store，管理告警邮箱页面所有接口请求与数据状态
 *
 * @author By AICode
 * @date 2026-04-10
 */
import axios from "axios";
import axiosCommon from "@/api/axiosCommon";


const alert = {
  namespaced: true,
  state: {
    tableData: [],
    tableLoading: false,
    submitLoading: false,
    selectedRowKeys: [],
    searchText: "",
    starTime: "",
    endTime: "",
    pagination: { current: 1, pageSize: 10, total: 0 },
    modalVisible: false,
    modalMode: "create",
    activeRecord: { id: undefined, applicantName: "", emailList: [] },
  },
  mutations: {
    // SET_TABLE_DATA - By AICode
    SET_TABLE_DATA(state, data) {
      state.tableData = data;
    },
    // SET_TABLE_LOADING - By AICode
    SET_TABLE_LOADING(state, loading) {
      state.tableLoading = loading;
    },
    // SET_SUBMIT_LOADING - By AICode
    SET_SUBMIT_LOADING(state, loading) {
      state.submitLoading = loading;
    },
    // SET_SELECTED_ROW_KEYS - By AICode
    SET_SELECTED_ROW_KEYS(state, keys) {
      state.selectedRowKeys = keys;
    },
    // SET_SEARCH_TEXT - By AICode
    SET_SEARCH_TEXT(state, text) {
      state.searchText = text;
    },
    // SET_STAR_TIME - By AICode
    SET_STAR_TIME(state, time) {
      state.starTime = time;
    },
    // SET_END_TIME - By AICode
    SET_END_TIME(state, time) {
      state.endTime = time;
    },
    // SET_PAGINATION - By AICode
    SET_PAGINATION(state, pagination) {
      state.pagination = { ...state.pagination, ...pagination };
    },
    // SET_MODAL_VISIBLE - By AICode
    SET_MODAL_VISIBLE(state, visible) {
      state.modalVisible = visible;
    },
    // SET_MODAL_MODE - By AICode
    SET_MODAL_MODE(state, mode) {
      state.modalMode = mode;
    },
    // SET_ACTIVE_RECORD - By AICode
    SET_ACTIVE_RECORD(state, record) {
      state.activeRecord = record;
    },
    // 重置筛选条件并将页码归 1 - By AICode
    RESET_FILTER(state) {
      state.searchText = "";
      state.starTime = "";
      state.endTime = "";
      state.pagination = { ...state.pagination, current: 1 };
    },
  },
  actions: {
    // 查询告警邮箱列表 - By AICode
    async fetchList({ commit, state }) {
      commit("SET_TABLE_LOADING", true);
      try {
        const result = await axiosCommon.post("/rest/mgmt/alertEmail/list", {
          searchText: state.searchText,
          starTime: state.starTime,
          endTime: state.endTime,
          pageNo: state.pagination.current,
          pageSize: state.pagination.pageSize,
        });
        const data = result || {};
        const results = Array.isArray(data.results) ? data.results : [];
        commit("SET_TABLE_DATA", results);
        commit("SET_PAGINATION", {
          total: data.totalRecord || 0,
          current: data.pageNo || state.pagination.current,
          pageSize: data.pageSize || state.pagination.pageSize,
        });
      } finally {
        commit("SET_TABLE_LOADING", false);
      }
    },
    // 新建告警邮箱记录 - By AICode
    async addAlertEmail(_, params) {
      const result = await axiosCommon.post("/rest/mgmt/alertEmail/add", params);
     
      return result
    },
    // 更新告警邮箱记录 - By AICode
    async updateAlertEmail(_, params) {
      const result = await axiosCommon.post("/rest/mgmt/alertEmail/update", params);
     
      return result
    },
    // 删除告警邮箱记录 - By AICode
    async deleteAlertEmail({ commit, dispatch }, params) {
      commit("SET_TABLE_LOADING", true);
      try {
        const result = await axiosCommon.post("/rest/mgmt/alertEmail/delete", params);
        if (result === true) {
          commit("SET_SELECTED_ROW_KEYS", []);
          await dispatch("fetchList");
        } else {
          commit("SET_TABLE_LOADING", false);
        }
        return result;
      } finally {
        commit("SET_TABLE_LOADING", false);
      }
    },
    // 导入告警邮箱（Excel 文件上传） - By AICode
    async importAlertEmail({ commit, dispatch }, file) {
      commit("SET_TABLE_LOADING", true);
      try {
        const formData = new FormData();
        formData.append("file", file);
        // 文件上传需置空默认 Content-Type，让浏览器自动携带 multipart/form-data boundary - By AICode
        const result = await axiosCommon.post(
          "/rest/mgmt/alertEmail/import",
          formData,
          {
            headers: { "Content-Type": undefined },
          },
        );
        if (!result.msg) {
          commit("SET_PAGINATION", { current: 1 });
          await dispatch("fetchList");
        } else {
          commit("SET_TABLE_LOADING", false);
        }
        return result
      } finally {
        commit("SET_TABLE_LOADING", false);
      }
    },
    // 导出告警邮箱（返回完整 response 供组件处理 blob 下载） - By AICode
    async exportAlertEmail(_, params = {}) {
      const response = await axios({
        method: "get",
        url: "/rest/mgmt/alertEmail/export",
        params,
        responseType: "blob",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        timeout: 60000,
      });
      return response;
    },
  },
};

export default alert;
